const segmentation = {
    state: () => ({
        
    }),

    mutations: {
        
    },

    getters: {
        
    }
}

export default segmentation;
